module.exports = __webpack_public_path__ + "img/swiper-9.666054d9.jpg";